
export const countryCodeMap: Record<string, string> = {
  IN: '+91',
  AE: '+971',
  SA: '+966',
  BD: '+880',
  TH: '+66',
  GH: '+233',
  PH: '+63',
  CI: '+225',
  NP: '+977'
};